const HowItWorksContent = [
    {
        icon: 'location',
        text: 'Our team are <span class="semi-bold">searching our database</span>' +
        ' to find the perfect mortgage adviser for you.',

    },
    {
        icon: 'bubbles',
        text: '<span class="semi-bold">The chosen mortgage advisers will be in touch</span> to discuss your request.',
    },
    {
        icon: 'tick',
        text: 'If you <span class="semi-bold">find a mortgage adviser that\'s right for you</span>, ' +
        'let them do what they do best!',
    },
];

export default HowItWorksContent;



// WEBPACK FOOTER //
// ./src/content/NextStepsContent.js